import ActionType from './ActionType'
import BodyArea from './BodyArea'
import Equipment from './Equipment'
import User from './User'

type Action = {
  id?: string
  title: string
  description: string
  videoUrl: string
  setsAndReps: string
  steps: string
  thumbnailUrl: string
  author: User
  actionType: ActionType
  bodyAreas: BodyArea[]
  equipment: Equipment[]
}
export default Action

export const actionToJson = (action: Action) => {
  const {
    title,
    description,
    videoUrl,
    setsAndReps,
    steps,
    thumbnailUrl,
    actionType,
    bodyAreas,
    equipment,
  } = action
  return {
    title,
    description,
    videoUrl,
    setsAndReps,
    steps,
    thumbnailUrl,
    actionTypeId: actionType.id,
    bodyAreaIds: bodyAreas.map((e) => e.id),
    equipmentIds: equipment.map((e) => e.id),
  }
}

export const actionFromJson = (json: object) => json as Action
